import { createContext, useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import da from "@/content/da";

const Ctx = createContext(null);
const KEY = "lurio_explorer_name";
const EVENT_KEY = "lurio_name_entered";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ExplorerProvider = ({ children }) => {
  const [name, setName] = useState(() => {
    try {
      return localStorage.getItem(KEY) || "";
    } catch {
      return "";
    }
  });
  const timer = useRef(null);
  useEffect(() => {
    try {
      localStorage.setItem(KEY, name);
    } catch {}
    // Anonymous analytics: one "name_entered" event per session, timestamp only.
    if (name.trim().length < 2 || sessionStorage.getItem(EVENT_KEY)) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      sessionStorage.setItem(EVENT_KEY, "1");
      axios.post(`${API}/events`, { type: "name_entered" }).catch(() => sessionStorage.removeItem(EVENT_KEY));
    }, 900);
    return () => clearTimeout(timer.current);
  }, [name]);
  const t = da;
  const display = name.trim();
  return <Ctx.Provider value={{ name, setName, display, hasName: !!display, t }}>{children}</Ctx.Provider>;
};

export const useExplorer = () => useContext(Ctx);
